import React from 'react';
import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const RefrigeratedAirDryerWidget = ({
  width = 140,
  height = 167,
  color,
  ...rest
}: {
  width: number;
  height: number;
  color: string;
  dry?: boolean;
  [key: string]: unknown;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentColor = color ?? token.colorBgContainer;

  return (
    <svg width={width} height={height} viewBox="0 0 140 167" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5 88.5H3C1.89543 88.5 1 87.6046 1 86.5L1 78.5C1 77.3954 1.89543 76.5 3 76.5H5L5 88.5Z"
        fill={token.colorBorder}
      />
      <g filter="url(#filter0_ddd_24621_1665)">
        <mask id="path-2-inside-1_24621_1665" fill={currentColor}>
          <path d="M5 10C5 6.68629 7.68629 4 11 4H129C132.314 4 135 6.68629 135 10V62H5V10Z" />
        </mask>
        <path d="M5 10C5 6.68629 7.68629 4 11 4H129C132.314 4 135 6.68629 135 10V62H5V10Z" fill={currentColor} />
        <path
          d="M5 4H135H5ZM135 63H5V61H135V63ZM5 62V4V62ZM135 4V62V4Z"
          fill={token.colorBorderSecondary}
          mask="url(#path-2-inside-1_24621_1665)"
        />
        <path
          d="M5.5 62.5H134.5V139C134.5 142.038 132.038 144.5 129 144.5H11C7.96243 144.5 5.5 142.038 5.5 139V62.5Z"
          fill={currentColor}
        />
        <path
          d="M5.5 62.5H134.5V139C134.5 142.038 132.038 144.5 129 144.5H11C7.96243 144.5 5.5 142.038 5.5 139V62.5Z"
          stroke={currentColor}
        />
        <path
          d="M17 145H123V159C123 160.105 122.105 161 121 161H19C17.8954 161 17 160.105 17 159V145Z"
          fill={currentColor}
        />
      </g>
      <path
        d="M135 76.5H137C138.105 76.5 139 77.3954 139 78.5V86.5C139 87.6046 138.105 88.5 137 88.5H135V76.5Z"
        fill={token.colorBorder}
      />
      <defs>
        <filter
          id="filter0_ddd_24621_1665"
          x="0"
          y="0"
          width="140"
          height="167"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24621_1665" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_24621_1665" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_24621_1665" result="effect2_dropShadow_24621_1665" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_24621_1665" result="effect3_dropShadow_24621_1665" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_24621_1665" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default RefrigeratedAirDryerWidget;
